const copyText = async (value: string) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }

  const textarea = document.createElement("textarea");
  textarea.value = value;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.append(textarea);
  textarea.select();
  const copied = document.execCommand("copy");
  textarea.remove();
  if (!copied) throw new Error("Clipboard copy was not available.");
};

const copyButtonLabels = () =>
  document.documentElement.lang === "en"
    ? { initial: "Copy email", success: "Email copied", failure: "Copy failed" }
    : { initial: "复制邮箱", success: "邮箱已复制", failure: "复制失败" };

export const initializeEmailCopyButtons = () => {
  document.querySelectorAll<HTMLButtonElement>("[data-copy-email]").forEach((button) => {
    const initialLabels = copyButtonLabels();
    button.setAttribute("aria-label", initialLabels.initial);
    button.title = initialLabels.initial;

    button.addEventListener("click", async () => {
      const email = button.dataset.copyEmail;
      if (!email) return;

      const labels = copyButtonLabels();
      try {
        await copyText(email);
        button.setAttribute("aria-label", labels.success);
        button.title = labels.success;
        button.classList.add("is-copied");
      } catch {
        button.setAttribute("aria-label", labels.failure);
        button.title = labels.failure;
        button.classList.remove("is-copied");
      }

      window.setTimeout(() => {
        const resetLabels = copyButtonLabels();
        button.setAttribute("aria-label", resetLabels.initial);
        button.title = resetLabels.initial;
        button.classList.remove("is-copied");
      }, 1800);
    });
  });
};
